import get from 'lodash.get';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectDocuments } from 'services/documents/selectors';
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';
import { DocumentUuid } from 'services/documents/types';

const selectDocument = createDeepEqualSelector(
    [selectDocuments, makeSelectQueryStringValue('uuid')],
    (documents, uuid: DocumentUuid) => get(documents, uuid)
);

export { selectDocument };
